// The nav badges (new leads, things to chase). Pages call
// notifyCountsChanged() after they change something, so the badge drops the
// moment a lead is quoted or a quote is written off — not on the next visit.

import { useCallback, useEffect, useState } from "react";
import { listLeads } from "../api/leads";
import { listQuotes } from "../api/quotes";
import { listQuoteRequests } from "../api/quotePage";
import { listEmailDrafts } from "../api/email";
import { buildFollowups } from "./followups";
import { useLiveRefresh } from "./live";

const EVENT = "bb:nav-counts";

export function notifyCountsChanged() {
  window.dispatchEvent(new Event(EVENT));
}

export function useNavCounts() {
  const [counts, setCounts] = useState({ inbox: 0, followups: 0 });

  const refresh = useCallback(async () => {
    try {
      const [leads, quotes, requests, emails] = await Promise.all([
        listLeads().catch(() => []),
        listQuotes({}).catch(() => []),
        listQuoteRequests().catch(() => []),
        listEmailDrafts().catch(() => []),
      ]);
      const f = buildFollowups(quotes, leads);
      const toApprove =
        emails.filter((e) => e.status === "draft").length +
        quotes.filter((q) => q.status === "draft" && q.send_requested_at).length;
      setCounts({ inbox: f.newLeads.length, followups: f.count + requests.length + toApprove });
    } catch {
      /* badges are a nicety — never break the page over them */
    }
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener(EVENT, refresh);
    return () => window.removeEventListener(EVENT, refresh);
  }, [refresh]);
  // Badges follow new alerts, returning to the app, and a slow poll.
  useLiveRefresh(refresh, { everyMs: 120000 });

  return counts;
}
